import { render, staticRenderFns } from "./ItemFormCards.vue?vue&type=template&id=5349056c"
import script from "./ItemFormCards.vue?vue&type=script&lang=js"
export * from "./ItemFormCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports